// extracted by mini-css-extract-plugin
export default {"description":"CustomCopyField_description__8ThLX"};